// extracted by mini-css-extract-plugin
export default {"buttonContainer":"_3ghOk","alignToEdge":"Pa3Bl","buttonIcon":"CL9lN","buttonCaption":"LB2wY","buttonSpacer":"JMDq3"};